import Slider from "@mui/material/Slider";
import styles from "../styles/FilterComponents.module.scss";
import classnames from "classnames";
import type { SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setTemporaryPeriod } from "../../../store/slices/filters.slice";
import ClearButton from "./ClearButton";
import { useAppSelector } from "../../../store/store";

const minDistance = 0;

interface IProps {
  isMobile: boolean;
  className?: string;
  setPeriodValue?: any;
  setPeriodValueCommitted?: any;
  period?: any;
  clearFiltersHandler: () => void;
  fromPageFlag: boolean;
}

const PeriodModule = ({
  isMobile,
  className,
  setPeriodValue,
  setPeriodValueCommitted,
  period,
  clearFiltersHandler,
  fromPageFlag,
}: IProps) => {
  const { t } = useTranslation();
  const maxYear = useAppSelector((state: any) => state.filters.maxYear);

  const dispatch = useDispatch();

  const handleChange1 = (event: Event, newValue: number | number[], activeThumb: number) => {
    if (!Array.isArray(newValue)) {
      return;
    }

    if (activeThumb === 0) {
      const val = [Math.min(newValue[0], period[1] - minDistance), period[1]];
      setPeriodValue(val);
      dispatch(setTemporaryPeriod(val));
    } else {
      const val = [period[0], Math.max(newValue[1], period[0] + minDistance)];
      setPeriodValue(val);
      dispatch(setTemporaryPeriod(val));
    }
  };

  const handleChangeCommitted = (_event: SyntheticEvent | Event, newValue: number | number[]) => {
    if (!Array.isArray(newValue)) {
      return;
    }

    const val = [Math.max(1980, newValue[0]), Math.min(maxYear, newValue[1])];
    setPeriodValueCommitted?.(val);
  };

  return (
    <div className={`${isMobile ? styles.periodWrapperMobile : classnames(styles.periodWrapper, className)}`}>
      <div
        className={`
        ${isMobile ? styles.titleMobile : styles.title}
        ${fromPageFlag ? styles.titleFromPage : ""}
      `}
      >
        <span>
          {t("period")}
          <ClearButton
            clearFiltersHandler={clearFiltersHandler}
            hideBtn={period[0] === 1980 && period[1] === maxYear}
          />
        </span>
      </div>
      <div className={styles.dateWrapper}>
        <div className={`${isMobile ? styles.dateItemMobile : styles.dateItem}`}>{period[0]}</div>
        <div className={`${isMobile ? styles.dateItemMobile : styles.dateItem}`}>{period[1]}</div>
      </div>
      <Slider
        min={1980}
        max={maxYear}
        className="period-controller"
        getAriaLabel={() => "Minimum distance"}
        value={period}
        onChange={handleChange1}
        onChangeCommitted={handleChangeCommitted}
        disableSwap
      />
    </div>
  );
};

export default PeriodModule;
